import api from "./api";
import { gvmPath } from "./apiPaths";

const ENDPOINT_NAME = "/users-by-role";

export type BouncerRoleName =
  | "VENDOR_MANAGER"
  | "CATEGORY_MANAGER"
  | "FINANCE_MANAGER";

export type BouncerRoleUser = {
  user_id: number;
  user_name: string;
  email_id: string;
  role_id: number;
  role_name: BouncerRoleName | string;
  user_to_role_id: number;
};

type UsersToRolesResponse = {
  count: number;
  items: BouncerRoleUser[];
  total_count: number;
  is_next: boolean;
  is_next_page_start?: number;
  is_next_page_count?: number;
};

const PAGE_SIZE = 100;
const MAX_PAGES = 20;

// Fetches all users with the given role via VIP's onboarding proxy — so callers
// need only FULFILMENT_ACCOUNTS_PAYABLE_BOUNCER_VIEW on this route instead of
// the broader Bouncer users-to-roles read.
export async function fetchUsersByRole(
  role: BouncerRoleName,
): Promise<BouncerRoleUser[]> {
  const all: BouncerRoleUser[] = [];
  let start = 0;
  for (let page = 0; page < MAX_PAGES; page += 1) {
    const params = new URLSearchParams({
      role,
      start: String(start),
      count: String(PAGE_SIZE),
    });
    const url = `${gvmPath(ENDPOINT_NAME)}?${params.toString()}`;
    const res = (await api.get(url)) as UsersToRolesResponse;
    if (!res || !Array.isArray(res.items)) break;
    all.push(...res.items);
    if (!res.is_next) break;
    // Trust the server's own cursor when supplied — a clamped PAGE_SIZE would
    // otherwise skip every other window silently. Fall back to what the server
    // actually returned so pagination still terminates when the cursor is absent.
    start =
      res.is_next_page_start ??
      start + (res.items.length > 0 ? res.items.length : PAGE_SIZE);
    if (page === MAX_PAGES - 1) {
      console.warn(
        `[bouncerUsers] role=${role} exceeded MAX_PAGES (${MAX_PAGES}) — truncating at ${all.length} users. Dropdown may be incomplete.`,
      );
    }
  }
  return all;
}
